// @ts-nocheck
import React, { useState } from 'react';
import { FieldsInputTitle } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/FieldsInputTitle';
import { Box, Typography } from '@mui/material';
import ImageAttachments from './components/ImageAttachments';

const ImageUploadFormFieldPreview = ({ element, answer, handleDirty }) => {
  const [imageAttachment, setImageAttachment] = useState(answer || []);

  return (
    <Box key={element?.id} m={1}>
      <FieldsInputTitle
        label={element?.label || element?.name}
        isRequired={element?.isRequired}
      />
      <ImageAttachments
        inputId={element?.id}
        attachmentTitle="Click/Drag here to upload Image"
        imageFileAttachment={imageAttachment}
        setImageFileAttachment={setImageAttachment}
        field={element}
        handleDirty={handleDirty}
      />
      <Box mt={1}>
        <Typography variant="body2" color="textSecondary">
          Maximum file size: 25 MB
        </Typography>
      </Box>
    </Box>
  );
};
export default ImageUploadFormFieldPreview;
